import { Injectable } from '@angular/core';
import { QualityControlAuthService } from '../../../../common/quality-control/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class FiltersAuthQcService extends QualityControlAuthService {
  protected totalPermits = ['QualityControl', 'Admin'];
  // Roles allowed to CREATE and PERFORM inspections (registerData /
  // validateTests). Methods that delete, edit templates, etc. stay
  // restricted to `totalPermits` (Admin / QualityControl) by inheriting the
  // base-class implementations.
  protected rolesToRegisterData = [
    'QualityControlInspector',
    'FiltersQC',
    'FiltersQualityControl',
  ];

  registerData(): boolean {
    return this.accessTo(this.rolesToRegisterData);
  }

  validateTests(): boolean {
    return this.accessTo(this.rolesToRegisterData);
  }

  totalInspection(): boolean {
    return this.accessTo(['QualityControl']);
  }

  /**
   * Filters-specific override: allow the same people who can create / perform
   * inspections (`rolesToRegisterData`) to also print labels with a custom
   * quantity from the QC view. `totalPermits` (Admin, QualityControl) are
   * granted automatically by `accessTo`.
   */
  override printLabelWithQuantity(): boolean {
    return this.accessTo(this.rolesToRegisterData);
  }
}
